import { apiVersionApi } from '@data/rest/api';
import { useQuery } from '@tanstack/react-query';
var apiVersionKey = ['apiVersion'];
export function useApiVersion() {
    return useQuery(apiVersionKey, apiVersionApi.get);
}
